import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { HeaderTemplateData } from '../dialog-data.interface';
import { SharedService } from '../../../../services/shared.service';

@Component({
    selector: 'dialog2-template',
    templateUrl: 'dialog2-template.html',
    styleUrls: ['dialog2-template.scss']
})
export class Dialog2Template implements OnInit {

    header:HeaderTemplateData;
    constructor(
        public dialogRef: MatDialogRef<Dialog2Template>,
        @Inject(MAT_DIALOG_DATA) private data: HeaderTemplateData,
        public shareService:SharedService,

    ) {
        if(data){
            this.header = data;
        }
    }

    ngOnInit() {
       
    }

    download(attachment) {
        window.open(attachment.resourceUrl)
        this.shareService.insertDownloadLog(attachment.fileName,attachment.fileSize,location.href,attachment.ID).subscribe();
    }
}
